// src/components/WiggiWiggiGame/InstructionsPanel.js
import React from 'react';
import {
    UNIT_TYPES,
    COLOR_DEFAULT_HEX,
    COLOR_MOVE,
    COLOR_ATTACK,
    COLOR_IDOL_GOLD,
    COLOR_BUSH
} from './constants';

// Simple functional component for static instructions
const InstructionsPanel = () => {
    // Helper to render the colored square span
    const ColorSwatch = ({ color }) => (
        <span style={{ display: 'inline-block', width: '1em', height: '1em', backgroundColor: color, border: '1px solid #ccc', marginRight: '0.3em', verticalAlign: 'middle' }}></span>
    );

    return (
        <div style={{ marginTop: '1rem', padding: '1rem', backgroundColor: '#f7fafc', borderRadius: '0.25rem', width: '100%', maxWidth: '800px', border: '1px solid #e2e8f0' }}>
            <h3 style={{ fontWeight: 'bold' }}>How to Play:</h3>
            <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                {/* ... other list items ... */}
                <li>Click your units (pale blue bases) to select them. Hover over any unit to see its name.</li>
                <li>Enemy units (red bases) are only visible when in sight range (or proximity) of your units.</li>
                <li>Background hexes are <ColorSwatch color={COLOR_DEFAULT_HEX} /> light brown.</li>
                <li><ColorSwatch color={COLOR_MOVE} /> Lighter tan hexes show where the selected unit can move (including the enemy 🍌!).</li>
                <li><ColorSwatch color={COLOR_ATTACK} /> Red hexes show enemy units the selected unit can attack.</li>
                <li>Click a tan hex to move, or a red hex to attack. Moving onto the enemy 🍌 captures it and wins! Defeating other units lets you move into their hex (unless you're a 🥥 or 🎈).</li>
                <li>The golden area ( <ColorSwatch color={COLOR_IDOL_GOLD} /> ) with the gray center ( <ColorSwatch color={COLOR_BUSH} /> ) housing the 🍌 is the impassable Giant Banana Idol.</li>
                <li>Protect your Sacred Banana Tree (🍌) - if the enemy moves onto it, you lose!</li>
                <li>The <ColorSwatch color={COLOR_BUSH} /> green hexes are overgrown bushes.</li>
                <li>🏏 **Coconut Clubbers** are basic melee units.</li>
                <li>🪓 **Bushwhackers** can move through and clear bushes.</li>
                <li>🥥 **Coconut Throwers** can attack from 2 hexes away. They don't move after attacking.</li>
                <li>💥 **Exploding Runners** move fast (4 hexes) but explode when moving onto *any* other unit (friendly or enemy, except Idols/Trees), destroying both! (Shows 💥 effect for 2s).</li>
                {/* --- MODIFIED BOMBER DESCRIPTION --- */}
                <li>
                    🎈 **Coconut Bombers** fly over bushes (but not idols/units), crash after 10 turns once activated by moving. Their sight range decreases over time.
                    They can perform a single attack (Range 1) **only once per game**. After attacking, they cannot attack again and remain in place. Only other Bombers can attack them.
                </li>
                {/* --- END MODIFICATION --- */}
                <li><strong>Win by:</strong> Moving a valid unit onto the enemy's Sacred Banana Tree hex OR eliminating all other enemy units.</li>
                <li><strong>Lose by:</strong> Having the enemy move onto your Sacred Banana Tree hex OR losing all your other units.</li>
            </ul>
            <h3 style={{ fontWeight: 'bold', marginTop: '1rem' }}>Unit Types:</h3>
            {/* --- UNIT STATS SECTION (Update Bomber stats display if desired) --- */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0.5rem', marginTop: '0.5rem' }}>
                {Object.entries(UNIT_TYPES).map(([key, stats]) => (
                     <div key={key}>
                           <strong>{stats.icon} {stats.name}</strong>
                           {/* Example simplified stats display - adjust as needed */}
                           {stats.attack > 0 && <span> (Atk:{stats.attack})</span>}
                           {stats.health > 0 && stats.health < 9000 && <span> (HP:{stats.health})</span>}
                           {stats.moveRange > 0 && <span> (Mv:{stats.moveRange})</span>}
                           {stats.attackRange > 0 && <span> (Rng:{stats.attackRange})</span>}
                           {stats.sightRange > 0 && <span> (Sight:{stats.sightRange})</span>}
                            {stats.type === 'COCONUT_BOMBER' && <span> (Sight:Var, Timed Life, 1 Attack!)</span>} {/* Updated Bomber stats summary */}
                           {stats.type === 'EXPLODING_COCONUT_RUNNER' && <span> (Explodes!)</span>}
                           {stats.type === 'IDOL_STONE' && <span> (Impassable)</span>}
                           {stats.canClearBushes && <span style={{ fontStyle: 'italic' }}> - Clears bushes</span>}
                     </div>
                ))}
            </div>
        </div>
    );
};

export default InstructionsPanel;